export const projectData = {
    'enchanting_forrest': {
        title: 'Enchanting Forrest',
        date: 'December 2022',
        location: 'Prigen',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/1%20Enchanting%20Forest%20-%20Prigen-26.webp?updatedAt=1750565800340',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-01.webp?updatedAt=1750565836529',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-03.webp?updatedAt=1750565794910',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-13.webp?updatedAt=1750565796952',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-15.webp?updatedAt=1750565799464',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-16.webp?updatedAt=1750565798499',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-18.webp?updatedAt=1750565798727',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-21.webp?updatedAt=1750565796124',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-22.webp?updatedAt=1750565835909',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-24.webp?updatedAt=1750565801160',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-27.webp?updatedAt=1750565804595',
            'https://ik.imagekit.io/imgkan/projects/enchanting_forest-prigen/Enchanting%20Forest%20-%20Prigen-28.webp?updatedAt=1750565807019'
            ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'enchanting_valley': {
        title: 'Enchanting Valley',
        date: 'December 2022',
        location: 'Cisarua',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/1%20Amarta-05.webp?updatedAt=1750565909570',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-01.webp?updatedAt=1750565907216',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-02.webp?updatedAt=1750565903778',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-15.webp?updatedAt=1750565909083',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-17.webp?updatedAt=1750565904575',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-27.webp?updatedAt=1750565905887',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-30.webp?updatedAt=1750565907852',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-31.webp?updatedAt=1750565909523',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-32.webp?updatedAt=1750565926737',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-35.webp?updatedAt=1750565909982',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-36.webp?updatedAt=1750565927033',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-37.webp?updatedAt=1750565926020',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-38.webp?updatedAt=1750565926612',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-39.webp?updatedAt=1750565927705',
            'https://ik.imagekit.io/imgkan/projects/enchanting_valley-cisarua/Amarta-40.webp?updatedAt=1750565927132'
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'foodhall': {
        title: 'Food Hall',
        date: 'October 2023',
        location: 'PIK Avenue',
        category: 'Supermarket',
        description: 'A sophisticated renovation of a waterfront restaurant, creating an elegant dining experience with panoramic views.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/1%20Food%20Hall%20-%20PIK%20Avenue-07.webp?updatedAt=1750566149925',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-01.webp?updatedAt=1750566152630',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-02.webp?updatedAt=1750566150886',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-03.webp?updatedAt=1750566153048',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-05.webp?updatedAt=1750566149866',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-09.webp?updatedAt=1750566152744',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-10.webp?updatedAt=1750566152470',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-12.webp?updatedAt=1750566151022',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-13.webp?updatedAt=1750566152570',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-15.webp?updatedAt=1750566154136',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-16.webp?updatedAt=1750566154737',
            'https://ik.imagekit.io/imgkan/projects/foodhall-pik/Food%20Hall%20-%20PIK%20Avenue-21.webp?updatedAt=1750566149613'
        ],
        details: [
            'Interior design renovation',
            'Kitchen modernization',
            'Outdoor seating area',
            'Lighting system upgrade'
        ]
    },
    'lamala': {
        title: 'Lamala',
        date: 'November 2023',
        location: 'Bintaro Jaya Xchange Mall',
        category: 'Retail',
        description: 'A complete transformation of a commercial space into a modern retail environment.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/1%20Lamala%20-%20BXC-07.webp?updatedAt=1750566180795',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-01.webp?updatedAt=1750566175568',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-02.webp?updatedAt=1750566181404',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-04.webp?updatedAt=1750566181698',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-08.webp?updatedAt=1750566180269',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-09-2.webp?updatedAt=1750566178919',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-09.webp?updatedAt=1750566177632',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-12.webp?updatedAt=1750566176185',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-13.webp?updatedAt=1750566180942',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-16.webp?updatedAt=1750566177419',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-20.webp?updatedAt=1750566183554',
            'https://ik.imagekit.io/imgkan/projects/lamala-bxc/Lamala%20-%20BXC-21.webp?updatedAt=1750566184789'
        ],
        details: [
            'Retail space optimization',
            'Modern storefront design',
            'Customer flow optimization',
            'Brand integration'
        ]
    },
    'simetri': {
        title: 'Simetri',
        date: 'December 2023',
        location: 'Kota Wisata',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/1%20Simetri%20_%20Kota%20Wisata-5.webp?updatedAt=1750566216891',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-08.webp?updatedAt=1750566213640',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-11.webp?updatedAt=1750566214224',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-12.webp?updatedAt=1750566214906',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-13.webp?updatedAt=1750566216665',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-19.webp?updatedAt=1750566217595',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-2.webp?updatedAt=1750566217457',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-3.webp?updatedAt=1750566217748',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-4.webp?updatedAt=1750566217587',
            'https://ik.imagekit.io/imgkan/projects/simetri-kota_wisata/Simetri%20_%20Kota%20Wisata-6.webp?updatedAt=1750566215068'
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'solo_safari': {
        title: 'Solo Safari',
        date: 'December 2023',
        location: 'Solo',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/1%20Solo%20Safari%20-%20Solo-16.webp?updatedAt=1750567797187',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-01.webp?updatedAt=1750567797259',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-02.webp?updatedAt=1750567798494',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-03.webp?updatedAt=1750567801432',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-04.webp?updatedAt=1750567801906',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-05.webp?updatedAt=1750567801806',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-06.webp?updatedAt=1750567801387',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-07.webp?updatedAt=1750567798578',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-08.webp?updatedAt=1750567801740',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-09.webp?updatedAt=1750567799792',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-10.webp?updatedAt=1750567802920',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-13.webp?updatedAt=1750567805164',
            'https://ik.imagekit.io/imgkan/projects/solo_safari-solo/Solo%20Safari%20-%20Solo-15.webp?updatedAt=1750567804755'
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'teazzi_bxc': {
        title: 'Teazzi Bintaro Jaya Xchange',
        date: 'December 2023',
        location: 'Bintaro Jaya Xchange Mall',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/1%20Teazzi%20-%20BXC-10.webp?updatedAt=1750567840668',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-02.webp?updatedAt=1750567839529',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-05.webp?updatedAt=1750567840606',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-06.webp?updatedAt=1750567839844',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-12.webp?updatedAt=1750567840460',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-13.webp?updatedAt=1750567840408',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-14.webp?updatedAt=1750567840762',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-16.webp?updatedAt=1750567844695',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-01.webp?updatedAt=1750567840028',
            'https://ik.imagekit.io/imgkan/projects/teazzi-bxc/Teazzi%20-%20BXC-03.webp?updatedAt=1750567840805',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    }, 
    'teazzi_galaxy_sby': {
        title: 'Teazzi Galaxy Mall',
        date: 'December 2023',
        location: 'Surabaya',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/1%20Teazzi%20-%20Galaxy%20Mall%20SBY-06.webp?updatedAt=1750567867637',
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/Teazzi%20-%20Galaxy%20Mall%20SBY-01.webp?updatedAt=1750567869790',
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/Teazzi%20-%20Galaxy%20Mall%20SBY-03.webp?updatedAt=1750567869724',
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/Teazzi%20-%20Galaxy%20Mall%20SBY-04.webp?updatedAt=1750567869806',
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/Teazzi%20-%20Galaxy%20Mall%20SBY-05.webp?updatedAt=1750567868835',
            'https://ik.imagekit.io/imgkan/projects/teazzi-galaxy_sby/Teazzi%20-%20Galaxy%20Mall%20SBY-09.webp?updatedAt=1750567869648',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },  
    'teazzi_lw': {
        title: 'Teazzi Living World',
        date: 'December 2023',
        location: 'Kota Wisata Cibubur',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/1%20Teazzi_Mall%20Living%20World-02-2.webp?updatedAt=1750567889850',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-02.webp?updatedAt=1750567890402',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-05.webp?updatedAt=1750567890366',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-06.webp?updatedAt=1750567890961',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-07.webp?updatedAt=1750567890232',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-12.webp?updatedAt=1750567891300',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-04.webp?updatedAt=1750567890504',
            'https://ik.imagekit.io/imgkan/projects/teazzi-living_world/Teazzi_Mall%20Living%20World-09.webp?updatedAt=1750567890976',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'varuna_bali': {
        title: 'Varuna',
        date: 'December 2023',
        location: 'Bali',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/1%20Varuna%20-%20Bali-01.webp?updatedAt=1750591703528',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-05.webp?updatedAt=1750591702520',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-06.webp?updatedAt=1750591703215',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-07.webp?updatedAt=1750591702744',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-09.webp?updatedAt=1750591703620',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-10.webp?updatedAt=1750591703448',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-15.webp?updatedAt=1750591703426',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-16.webp?updatedAt=1750591703861',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-17.webp?updatedAt=1750591703926',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-19.webp?updatedAt=1750591703722',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-21.webp?updatedAt=1750591706585',
            'https://ik.imagekit.io/imgkan/projects/varuna-bali/Varuna%20-%20Bali-28.webp?updatedAt=1750591706871',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },  
    'ziel_pik': {
        title: 'Ziel',
        date: 'December 2023',
        location: 'PIK Avenue',
        category: 'Residential',
        description: 'An elegant extension to a luxury residence, seamlessly blending modern architecture with existing structures.',
        images: [
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/1%20Ziel%20-%20PIK%20Avenue-08.webp?updatedAt=1750568099528',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-01.webp?updatedAt=1750568099799',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-02.webp?updatedAt=1750568099783',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-04.webp?updatedAt=1750568099751',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-05.webp?updatedAt=1750568099010',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-07.webp?updatedAt=1750568098375',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-09.webp?updatedAt=1750568099787',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-10.webp?updatedAt=1750568099831',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-14.webp?updatedAt=1750568096177',
            'https://ik.imagekit.io/imgkan/projects/ziel-pik_avenue/Ziel%20-%20PIK%20Avenue-13.webp?updatedAt=1750568099188',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'teazzi_gancit': {
        title: 'Teazzi Gandaria City',
        date: 'December 2023',
        location: 'Gandaria City',
        category: 'Residential',
        description: '',
        images: [
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/01%20Teazzi%20-%20Gancit-11.webp?updatedAt=1751821975278',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-10.webp?updatedAt=1751821974316',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-08.webp?updatedAt=1751821974639',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-04.webp?updatedAt=1751821974675',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-05.webp?updatedAt=1751821974125',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-02.webp?updatedAt=1751821974135',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-03.webp?updatedAt=1751821973499',
            'https://ik.imagekit.io/imgkan/projects/teazzi-gancit/Teazzi%20-%20Gancit-07.webp?updatedAt=1751821975219',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
    'mmn_pim': {
        title: 'No. 25 Minced Meat Noodles',
        date: 'December 2023',
        location: 'Puri Indah Mall',
        category: 'Residential',
        description: '',
        images: [
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/01%20MMN%20-%20PIN-01.webp?updatedAt=1751821277545',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-02.webp?updatedAt=1751821277880',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-04.webp?updatedAt=1751821277131',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-05.webp?updatedAt=1751821277979',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-06.webp?updatedAt=1751821277525',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-11.webp?updatedAt=1751821277354',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-12.webp?updatedAt=1751821276613',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-13.webp?updatedAt=1751821277716',
            'https://ik.imagekit.io/imgkan/projects/mmn-pim/MMN%20-%20PIN-09.webp?updatedAt=1751821278402',
        ],
        details: [
            'Architectural extension',
            'High-end finishes',
            'Landscape integration',
            'Smart home features'
        ]
    },
}; 